import React, {FC, useMemo} from 'react';
import {TablePagination, TnReactTable, useDatatable} from '@touchnet/react-table';
import {
    createColumnHelper,
    getCoreRowModel, getPaginationRowModel, getSortedRowModel,
} from '@tanstack/react-table';

import {AccountingCode} from '~/types/accounting-code-type'
import CodeListActionButton from './code-list-action-button';
import withCodes from "~/providers/with-codes.tsx";
import {withRouter} from "~/providers/with-router.tsx";

interface ComponentProps {
    codes: AccountingCode[];
}

export const CodesTable: FC = ({codes}: ComponentProps) => {
    const columns = useMemo(() => {
        const columnHelper = createColumnHelper<AccountingCode>();
        return [
            columnHelper.accessor('name', {
                header: 'Name',
                sortingFn: 'basic',
            }),
            columnHelper.display({
                id: 'actions',
                header: 'Actions',
                cell: ({row}) => <CodeListActionButton code={row.original} />,
            }),
        ];
    }, [codes]);

    const table = useDatatable({
        columns: columns,
        data: codes,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getRowId: row => row.id
    });

    return (
        <>
            <TnReactTable table={table} noDataText={'No Codes Found'} />
            <TablePagination table={table} />
        </>
    );
}


export default withCodes(withRouter(CodesTable));
